import { useAuth } from '../hooks/useAuth';

/**
 * Gates a route behind the local `role === 'admin'` claim.
 *
 * Assumes RequireAuth has already ensured the user is authenticated — so we
 * don't redirect here. While `/api/me` is loading we render a placeholder so
 * admins don't flash the "Access Denied" card on mount.
 */
const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return <div className="auth-loading">Loading...</div>;
  }

  if (user?.role !== 'admin') {
    return (
      <div className="container main-content">
        <div className="row">
          <div className="col">
            <div className="alert alert-danger" role="alert">
              <h4 className="alert-heading">Access Denied</h4>
              <p>You do not have permission to access this page.</p>
              <hr />
              <p className="mb-0">This area is restricted to administrators only.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default AdminRoute;
